import { RecoveryAccountProvider } from "../../Contexts/RecoveryAccountContext";
import { Outlet } from "react-router-dom";
import React from "react";

function Index() {
  return (
    <RecoveryAccountProvider>
      <Outlet />
    </RecoveryAccountProvider>
  );
}

export default Index;
